module.exports = __webpack_public_path__ + "static/img/6.c680655.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/6.png
// module id = f/EA
// module chunks = 0